import logo from './logo.svg';
import './App.css';
import { Waypoint } from 'react-waypoint';
import { Parallax, Background } from 'react-parallax';
import React, { useState, useEffect } from 'react';

function Page({data: {id, title, image, content, subtract, bgcolor, color}}) {
  let styling = {
    height: 'calc(100vh - ' + subtract +')', color: color, padding: '1em', boxSizing:'border-box'
  };
  if (image == 0) {
      styling.backgroundColor = bgcolor;
  }
  const page = <div className="page" style={styling}>
    <Waypoint
      onEnter={() => fadeIn(id)}
      /*onLeave={() => fadeOut(id)}*/
    >
      <div id={id} className="fade">
        <div><h2>{title}</h2></div>
        <div className="content fade slow">{content}</div>
      </div>
    </Waypoint>
  </div>;
  if (image != 0) {
    return (
      <Parallax blur={{ min: 15, max: -15 }} strength={200} bgImage={require('../public/sc'+image+'.png')}>
        {page}
      </Parallax>
    );
  } else return page;
}

function fadeIn(id) {
  let el = document.getElementById(id);
  if (!el.classList.contains('in')) {
    el.classList.add('in');
  }
}

function fadeOut(id) {
  let el = document.getElementById(id);
  if (el.classList.contains('in')) {
    el.classList.remove('in');
  }
}

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
  }
}

let track1 = true;

let landingpageshown = false;

function scrollUp() {
  if (!landingpageshown) {
    window.scrollTo(0, 0);
    setTimeout(() => {
      scrollUp();
    }, 100);
  }
}

function App() {

  function startMusic() {
    document.getElementById('ap1').currentTime = 1;
    document.getElementById('ap1').volume = 0.5;
    document.getElementById('ap1').play();
    document.getElementById('ap2').currentTime = 5;
  }

  useEffect(() => {
    scrollUp();
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    }
  });

  const menuHeight = '0vh';
  let contact = [
    {key: "pa", html: <div>
      <p>Pontus Asp - <a href="https://pontusasp.se" target="_blank">pontusasp.se</a></p>
    </div>},
    {key: "mh", html: <div>
      <p>Marcus Holmberg - marcush2@kth.se</p>
    </div>},
    {key: "da", html: <div>
      <p>David Åstrand - dastrand@kth.se</p>
    </div>},
    {key: "db", html: <div>
      <p>David Bergendorff - dbergen@kth.se</p>
    </div>},
    {key: "bb", html: <div>
      <p>Baptiste Brémond - b.bremond@kth.se</p>
    </div>}
  ];
  shuffleArray(contact);

  const landingPage = <div id="landingpage" onClick={() => {
    const lp = document.getElementById('landingpage');
    const lpf = document.getElementById('landingpageflash');
    const doors = document.getElementById('doors');
    doors.classList.add('open');
    lp.classList.add('fadeout');
    lpf.classList.add('in');
    lpf.classList.add('fast');
    lpf.classList.add('fade');
    setTimeout(() => {
      startMusic();
      lp.style.display='none';
    }, 3000);
    setTimeout(() => {
      document.body.style.overflow='auto';
      landingpageshown = true;
    }, 650);
  }}>
    <Page data={{
      id: "landingpageContent",
      title: <></>,
      image: 8,
      content: <>
      <div id="doors">
        <div id="doorleft"><img src="door_left.png"/></div>
        <div id="doorright"><img src="door_right.png"/></div>
      </div>
      <h2><span className="wondertype">Enter Wanderful</span></h2>
      </>,
      subtract: menuHeight,
      bgcolor: '#222',
      color: '#fff'
    }}/>
    <div id="landingpageflash"></div>
  </div>;

  const pages = [
    {
      id: "firstpage",
      title: <><img src="logo_1.png" style={{width: '25vw'}}/><br/><span className="wondertype">Wanderful</span></>,
      image: 7,
      content: <><p>is a fast paced top down shooter game.</p></>,
      subtract: menuHeight,
      bgcolor: '#422',
      color: '#fff'
    },
    {
      id: "secondpage",
      title: <>In a <span className="wondertype">Wanderful</span> setting</>,
      image: 1,
      content: <><p>with medieval and fantasy themed maps.</p></>,
      subtract: '0vh',
      bgcolor: '#242',
      color: '#fff'
    },
    {
      id: "thirdpage",
      title: <>But not everything is <span className="wondertype">Wanderful</span>...</>,
      image: 2,
      content: <><Waypoint
      onEnter={() => {
        if (track1) {
          track1=false;
          const volume = document.getElementById('ap1').volume;
          document.getElementById('ap2').volume = 0;
          if (!document.getElementById('ap1').paused) {
            function raisevolume() {
              const ap2 = document.getElementById('ap2');
              if (ap2.volume < volume) {
                ap2.volume += 0.01;
                setTimeout(raisevolume, 35);
              }
            }
            function lowervolume() {
              const ap1 = document.getElementById('ap1');
              const ap2 = document.getElementById('ap2');
              if (ap1.volume > 0) {
                if (ap1.volume < 0.01) ap1.volume = 0;
                else ap1.volume -= 0.01;
                setTimeout(lowervolume, 15);
              } else {
                console.log("switching audio");
                ap1.pause();
                ap2.play();
                raisevolume();
              }
            }
            lowervolume();
          }
        }
        }}/>
      <p>since you have been captured and have been experimented on by insane mages.</p></>,
      subtract: '0vh',
      bgcolor: '#224',
      color: '#fff'
    },
    {
      id: "fourthpage",
      title: <>In order to get your old <span className="wondertype">Wanderful</span> life back</>,
      image: 3,
      content: <><p>you will have to fight your way out.</p></>,
      subtract: '0vh',
      bgcolor: '#422',
      color: '#fff'
    },
    {
      id: "fifthpage",
      title: <>And face many challenging enemies of different kinds</>,
      image: 4,
      content: <><p>that are all trying to put you in your grave.</p></>,
      subtract: '0vh',
      bgcolor: '#242',
      color: '#fff'
    },
    {
      id: "sixthpage",
      title: <>Presenting <span className="wondertype">Wanderful</span></>,
      image: 0,
      content: <>
        <p>A new game posing difficult challenges with many levels and spells.</p>
        <p>Feel the adrenaline pump through your veins as you make it through your first level alive, and feel the progression of your skills as you sweep through it the next time as you get further every time you play.</p>
        <p>Find new spells as you play and manage your mana, while plowing down enemies that are all out to get you.</p>
      </>,
      subtract: '0vh',
      bgcolor: '#224',
      color: '#fff'
    },
    {
      id: "demopage",
      title: <>Download <span className="wondertype">Wanderful</span> now!</>,
      image: 0,
      content: <>
        <div className="fade slow">
          <div><iframe src="https://drive.google.com/file/d/1zoyE7ENryJkBmiOmA90FHUclZImaSPMN/preview" width="800" height="450" allow="autoplay"></iframe></div>
          <div style={{padding: '2em'}}>
            <a className="wondertype" style={{
              borderRadius: '1.2em',
              padding: '0.5em 1em',
              background: '#363',
              border: '1px solid #131',
              color: '#fff',
              textDecoration: 'none',
              margin: '2em'
            }} href="https://drive.google.com/file/d/1uAEMNwlu8RF3kNhbm9HCwXVea9DOMjnT/view?usp=sharing" target="_blank">Download</a>
          </div>
        </div>
      </>,
      subtract: '0vh',
      bgcolor: '#222',
      color: '#fff'
    },
    {
      id: "contactpage",
      title: <>Contact</>,
      image: 0,
      content: contact.map(({key, html}) => <div key={key}>{html}</div>),
      subtract: '50vh',
      bgcolor: '#363',
      color: '#fff'
    },
    {
      id: "aboutwanderful",
      title: <>About <span className="wondertype">Wanderful</span></>,
      image: 0,
      content: <>
        <p><span className="wondertype">Wanderful</span> is a game that was developed in two months by a group of five students at KTH Royal Institute of Technology during a course called DH2650 Computer Game Design.</p>
        <p>The game is developed in Unity and only uses free assets and assets made by the group.</p>
        <p>There are two different music tracks in the game, both composed by one of the students.</p>
      </>,
      subtract: '50vh',
      bgcolor: '#336',
      color: '#fff'
    },

  ].map((data) => <Page key={data.id} data={data}/>);

  const menu = (
    <div style={{overflow: 'hidden'}}>
      <header style={{minHeight: menuHeight, position: 'fixed'}} className="App-header">
        <p>I am a menu tralalala-la</p>
      </header>
      <div style={{minHeight: menuHeight, opacity: 0}} className="App-header">
        <p>Hello there little developer</p>
      </div>
    </div>
  );

  const musicPlayerStyle = {
    color: '#fff',
    display: 'inline-block',
    padding: '0.5em',
    cursor: 'pointer'
  };

  const music = (
    <div style={{position: 'fixed', left: 0, bottom: 0, zIndex: 11}} className="noselect">
      <audio id="ap1" style={{padding: '0'}} src="between-levels.mp3">
        Your browser does not support audio elements.
      </audio>
      <audio id="ap2" style={{padding: '0'}} src="theme.mp3">
        Your browser does not support audio elements.
      </audio>
      <div style={{borderRadius: '10em', backgroundColor: '#222a', padding: '0.15em 0.5em', margin: '1em'}}>
        <div style={musicPlayerStyle} onClick={() => document.getElementById(track1?'ap1':'ap2').volume -= 0.1}>-</div> 
        <div style={musicPlayerStyle} onClick={() => document.getElementById(track1?'ap1':'ap2').play()}>▶</div> 
        <div style={musicPlayerStyle} onClick={() => document.getElementById(track1?'ap1':'ap2').pause()}>| |</div> 
        <div style={musicPlayerStyle} onClick={() => document.getElementById(track1?'ap1':'ap2').volume += 0.1}>+</div> 
      </div>
    </div>
  );

  return (
    <div className="App">
      <div>
        {music}
      </div>
      <div>
        {landingPage}
        {pages}
      </div>
    </div>
  );
}

export default App;
